// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__7LBH-","noInteraction":"EventWrapper_noInteraction__3CBw1"};